import React from 'react';
import { Plus, Trash2, Clock } from 'lucide-react';

interface WorkingTime {
    daysOfWeek: number[];
    from: string;
    to: string;
}

interface WorkingTimeInputProps {
    value: WorkingTime[];
    onChange: (value: WorkingTime[]) => void;
}

const DAYS = [
    { label: 'L', value: 1 },
    { label: 'M', value: 2 },
    { label: 'M', value: 3 },
    { label: 'J', value: 4 },
    { label: 'V', value: 5 },
    { label: 'S', value: 6 },
    { label: 'D', value: 7 },
];

export const WorkingTimeInput: React.FC<WorkingTimeInputProps> = ({ value = [], onChange }) => {

    const handleAdd = () => {
        onChange([...value, { daysOfWeek: [1, 2, 3, 4, 5], from: '09:00', to: '18:00' }]);
    };

    const handleRemove = (index: number) => {
        const newValue = [...value];
        newValue.splice(index, 1);
        onChange(newValue);
    };

    const handleDayToggle = (index: number, dayValue: number) => {
        const newValue = [...value];
        const days = newValue[index].daysOfWeek;
        if (days.includes(dayValue)) {
            newValue[index].daysOfWeek = days.filter(d => d !== dayValue);
        } else {
            newValue[index].daysOfWeek = [...days, dayValue].sort((a, b) => a - b);
        }
        onChange(newValue);
    };

    const handleChangeTime = (index: number, field: 'from' | 'to', val: string) => {
        const newValue = [...value];
        newValue[index] = { ...newValue[index], [field]: val };
        onChange(newValue);
    };

    return (
        <div className="space-y-3">
            {value.map((item, index) => (
                <div key={index} className="bg-gray-50 dark:bg-gray-700/30 p-2 rounded-lg border border-gray-200 dark:border-gray-700 group relative">
                     {/* Remove Button - Top Right */}
                    <button
                        type="button"
                        onClick={() => handleRemove(index)}
                        className="absolute top-1 right-1 text-gray-400 hover:text-red-500 p-1 opacity-0 group-hover:opacity-100 transition-opacity"
                        title="Eliminar horario"
                    >
                        <Trash2 className="w-3.5 h-3.5" />
                    </button>

                    <div className="space-y-2">
                        {/* Days Selection */}
                        <div className="flex gap-1 justify-between pr-4">
                            {DAYS.map((day) => {
                                const isSelected = item.daysOfWeek.includes(day.value);
                                return (
                                    <button
                                        key={day.value}
                                        type="button"
                                        onClick={() => handleDayToggle(index, day.value)}
                                        className={`w-6 h-6 rounded flex items-center justify-center text-[10px] font-bold transition-all
                                            ${isSelected
                                                ? 'bg-blue-600 text-white shadow-sm'
                                                : 'bg-white dark:bg-gray-800 text-gray-500 dark:text-gray-400 border border-gray-200 dark:border-gray-600 hover:border-blue-300'
                                            }`}
                                        title={`Día ${day.value}`}
                                    >
                                        {day.label}
                                    </button>
                                );
                            })}
                        </div>

                        {/* Time Inputs */}
                        <div className="flex items-center gap-2">
                            <Clock className="w-3.5 h-3.5 text-gray-400" />
                            <input
                                type="time"
                                value={item.from}
                                onChange={(e) => handleChangeTime(index, 'from', e.target.value)}
                                className="px-1 py-0.5 text-xs bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded focus:ring-1 focus:ring-blue-500 w-20 text-center"
                            />
                            <span className="text-xs text-gray-400">-</span>
                            <input
                                type="time"
                                value={item.to}
                                onChange={(e) => handleChangeTime(index, 'to', e.target.value)}
                                className="px-1 py-0.5 text-xs bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded focus:ring-1 focus:ring-blue-500 w-20 text-center"
                            />
                        </div>
                    </div>
                </div>
            ))}

            <button
                type="button"
                onClick={handleAdd}
                className="w-full py-1.5 flex items-center justify-center gap-1.5 text-xs font-medium text-blue-600 bg-blue-50 hover:bg-blue-100 dark:bg-blue-900/20 dark:hover:bg-blue-900/30 dark:text-blue-400 rounded-lg border border-blue-200 dark:border-blue-800 border-dashed transition-colors"
            >
                <Plus className="w-3.5 h-3.5" />
                Agregar Horario
            </button>
        </div>
    );
};
